const formatAmount = (n, locale) => {
  const num = parseFloat(n) || 0;
  return num.toLocaleString(locale || "de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export default formatAmount;
